import React from 'react';
import { usePromiseTracker } from 'react-promise-tracker';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { RootState } from '../../../../../../@types/RootState';
import { LoadingSpinerLocal } from '../../../../../../components';
import { selectorRuleComposition, SET_IS_OPEN } from '../../../../../../reducers/ipa/priceManager/modals/ruleComposition';
import { CompositionRuleModal } from '../../CompositionRuleModal';

type RuleCompositionModalWrapperProps = ReturnType<typeof mapStateToProps> & ReturnType<typeof mapDispatchToProps>;

const RuleCompositionModalWrapper = ({ compositionRule, closeModal }: RuleCompositionModalWrapperProps) => {
  const { promiseInProgress } = usePromiseTracker({ area: 'composition-rule' });

  if (promiseInProgress) {
    return <LoadingSpinerLocal loading={promiseInProgress} size="md" height="100%" position="absolute" />;
  }

  return <CompositionRuleModal show={compositionRule.isOpen} onHide={closeModal} ruleComposition={compositionRule.data} />;
};

const mapStateToProps = (state: RootState) => ({
  compositionRule: selectorRuleComposition(state),
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  closeModal: () => dispatch(SET_IS_OPEN(false)),
});

export default connect(mapStateToProps, mapDispatchToProps)(RuleCompositionModalWrapper);
